import React from "react";
import OnboardingComplete from "../onboarding/OnboardingComplete";


export default function ConnectRefresh() {
  
  return (
    <>
      <OnboardingComplete completed={false} />;
    </>
  );
}